module.exports = __webpack_public_path__ + "static/pic08-68fe34b5001beb563108dac6d1a7c670.jpg";